import { render } from "./NewCosmosObject.vue?vue&type=template&id=0b01d33a&scoped=true"
import script from "./NewCosmosObject.vue?vue&type=script&lang=js"
export * from "./NewCosmosObject.vue?vue&type=script&lang=js"

import "./NewCosmosObject.vue?vue&type=style&index=0&id=0b01d33a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b01d33a"]])

export default __exports__